module.exports = __webpack_public_path__ + "static/hero-408e4f18fac7023fd561a44fc2df3a2b.ogv";